import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { track } from '../lib/analytics';

const LABEL: Record<'pro' | 'family', string> = { pro: 'Pro', family: 'Family' };

export function UpgradeModal({
  requiredTier,
  message,
  onClose,
}: {
  requiredTier: 'pro' | 'family';
  message: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();

  // Апселл показан — учитываем один раз на маунте (requiredTier на маунте стабилен).
  useEffect(() => {
    track('upsell_shown', { tier: requiredTier });
  }, [requiredTier]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-card"
      >
        <h2 className="text-lg font-bold text-ink">Нужен тариф {LABEL[requiredTier]}</h2>
        <p className="mt-2 text-sm text-ink/70">{message}</p>
        <div className="mt-5 flex flex-col gap-2">
          <button
            onClick={() => {
              track('upsell_click', { tier: requiredTier });
              navigate('/billing');
            }}
            className="w-full rounded-xl bg-primary-600 px-4 py-3 font-semibold text-white shadow-card transition active:scale-[0.98]"
          >
            Посмотреть тарифы
          </button>
          <button onClick={onClose} className="w-full rounded-xl px-4 py-3 font-semibold text-ink/60">
            Не сейчас
          </button>
        </div>
      </div>
    </div>
  );
}
